import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconKeyboardKeyLight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 6.879 6.879",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		clipRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M.622.27.106.86v5.133a.615.615 0 0 0 .617.617h5.101l.517-.591-5.067-.031L.8 5.744.65 5.256Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeMiterlimit: 1.5,
				strokeWidth: .212,
				d: "M.622.27.106.86v5.133a.615.615 0 0 0 .617.617h5.101l.517-.591"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeMiterlimit: 1.5,
				strokeWidth: .212,
				d: "M6.34 1.122A.853.853 0 0 0 5.489.27H.622v5c0 .414.336.749.749.749h4.97z"
			})
		]
	})
});
export default SvgIconKeyboardKeyLight;
